import { Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ModalAccionesUsuarioComponent} from '../modal-acciones-usuario/modal-acciones-usuario.component'
import { ModalAccionesLoccionesComponent } from '../modal-acciones-locciones/modal-acciones-locciones.component';

@Component({
  selector: 'app-componente-data6',
  templateUrl: './componente-data6.component.html',
  styleUrls: ['./componente-data6.component.scss']
})
export class ComponenteData6Component implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<ComponenteData6Component> = new Subject();
  tablavisible=false

  arraydeposts=[]
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''

  botondisabled=true
  arraydeempresas=[]

  usuario=null;
  procesodeEliminarActivo=false
  trabajando=false
  regional=''
  nombre=''


  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
    this.inicializadatatables(()=>{
      this.query1(()=>{
        this.dtTrigger.next();
      })
    })
  }

  rerender() {
    console.log("RERENDER")
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {        
      // Destroy the table first
      dtInstance.destroy();
      //reload your data
      this.query1(()=>{
         // Call the dtTrigger to rerender after callback
         this.dtTrigger.next();
      })
    });
  }

    query1(callback){
      this.arraydeposts=[];
      let query1 = firebase.firestore().collection("locaciones");
      
      query1.get().then((docs)=>{
        docs.forEach((doc)=>{
          this.arraydeposts.push(doc);
        })
      }).then(()=>{
        callback()
      }).catch((err)=>{
        console.log(err);
      })
    }

    inicializadatatables(callback) {
      this.dtOptions = {
        // Declare the use of the extension in the dom parameter
        dom: 'Bfrtip',
        "pageLength": 200,
        scrollX: false,
     
        // Configure the buttons
        buttons: [
          'colvis',
          'excel',
          // 'columnsToggle',
          'print'
        ]
      };
      callback()
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();
    }
  
  
    alerta(tipo,input){
      this.alertaActiva=true;
      this.mensajeAlerta=input;
      this.tipodeAlerta=tipo;
    }
  
  
  
    closeAlert(){
      this.alertaActiva=false
    }

    detalles(usuario){
      const modalRef = this.modalService.open(ModalAccionesLoccionesComponent);
      modalRef.componentInstance.usuario = usuario;//pasamos al modal el parámetro de usuario
    
      //para recibir data desde el modal
      modalRef.result.then((result) => {
        if (result=="OK") {
        this.rerender()
        }
        });
    }

  
    crearLocacion(){
      this.trabajando=true
      this.alerta("warning","Creando locación...")
      
      firebase.firestore().collection("locaciones").add({
        name: this.nombre,
        regional: this.regional
      })
      .then((docRef) => {
          console.log("Document written with ID: ", docRef.id);
          this.rerender()
          this.trabajando=false
          this.alerta("success","¡Locación creada!")
          
      })
      .catch((error) => {
        this.trabajando=false
        this.alerta("danger","Error: "+error)
        this.rerender()
      });
     
    }

    validaboton(){
      if(this.nombre==''||this.regional==''){this.botondisabled=true}else
      if(this.nombre!=''&& this.regional!=''){this.botondisabled=false}
    }



}//fin de clase
